export default {
    props: [
        'name',
        'date',
        'status',
        'type',
        'promotionId',
        'id',
    ],

    methods: {
        promotionType() {
            if(this.id === 1) {
                return `/promotion/new-promotion/base-settings/${this.promotionId}`;
            } else if (this.id === 2){
                return `/promotion/new-promotion/base-settings-hall/${this.promotionId}`;
            }

            return `/promotion/new-promotion/base-settings-dermo/${this.promotionId}`;
        },
    }
}